<template>
  <div>
    历史记录
  </div>
</template>

<script>
export default {
  name: "history",
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>